export default "__VITE_ASSET__DVcYvG$O__"